<template>
  <app-content>
    <app-content-body>

      <div class="inner">
        <p class="buttons">
          <a
            class="btn btn_action btn_add"
            title="Přidat jazyk"
            @click.prevent="createItem"
          >Přidat jazyk</a>
        </p>
        <h1 v-translate>Jazyky</h1>
      </div>

      <app-table
              clickable
              deletable
              noPagination
              :data="items"
              :highlight-rows-on-hover="true"
              :order="params.order"
              :page-size="params.limit"
              @sort="sortItems"
              @rowClick="goToDetail"
              @deleteRow="deleteItem"
              :loading="pending"
      >
        <template slot="header">
          <app-table-header-item class="field_left">
            <app-input
                    :label="translations.search"
                    name="search"
                    type="search"
                    v-model="search"
            />
          </app-table-header-item>
        </template>

        <app-table-column first sortable attribute="languageNames" :label="translations.name">
          <template slot-scope="row">
            <strong>
              <div v-html="row.languageName" />
            </strong>
          </template>
        </app-table-column>
        <app-table-column sortable attribute="isoCode" :label="translations.isoCode" />
        <app-table-column sortable attribute="deviceLanguage" :label="translations.deviceLanguage">
          <template slot-scope="row">
              <app-graphic-image
                  :value="row.deviceLanguage"
              />
          </template>
        </app-table-column>
        <app-table-column sortable attribute="numberOfSynonyms" :label="translations.numberOfSynonyms" />
        <app-table-column sortable attribute="created" :label="translations.created">
          <template slot-scope="row">
            <div v-html="formatDate(row._created)" />
          </template>
        </app-table-column>

        <template slot="footer" v-if="itemsMetadata.totalCount > params.limit">
          <app-table-pagination
              :page="listPage"
              :itemsPerPage="params.limit"
              :totalCount="itemsMetadata.totalCount"
              @pageChanged="tablePageChanged"
          />
        </template>

      </app-table>
    </app-content-body>
  </app-content>
</template>

<script>
import getItemsListMixin from 'mixins/getItemsListMixin'
import appTitleMixin from 'mixins/appTitleMixin'
import formatDateMixin from 'mixins/formatDateMixin'

const itemsListMixin = getItemsListMixin({
  apiMethodsSuffix: 'Languages'
})

export default {
  name: 'lanaguage-items',
  mixins: [formatDateMixin, itemsListMixin, appTitleMixin(['Jazyky'])],
  data() {
    return {
      search: ''
    }
  },
  created() {
    this.search = this.params.search
  },
  computed: {
    translations() {
      return {
        deviceLanguage: this.$gettext('Jazyk zařízení'),
        search: this.$gettext('Vyhledávání'),
        name: this.$gettext('Název'),
        isoCode: this.$gettext('ISO 639-3'),
        created: this.$gettext('Založeno'),
        numberOfSynonyms: this.$gettext('Počet synonym')
      }
    },
    currentLanguage() {
      return this.$language.current
    },
    currentTitle() {
      return [
        this.$gettext('Jazyky')
      ]
    }
  },
  methods: {
    shouldRefreshAfterDelete() {
      return true
    }
  },
  watch: {
    currentLanguage() {
      this.fetchItems()
    },
    items() {
      this.items.forEach(e => e.numberOfSynonyms = e.synonyms.length)
    },
    search: function (newVal, oldVal) {
      if (newVal.length >= 2) {
        this.params.search = this.search
        this.fetchItems()
      } else if (newVal.length < 2 && oldVal.length >= 2) {
        this.params.search = ''
        this.fetchItems()
      }
    }
  }
}
</script>
